import styled from 'styled-components';
import AddGuestSvg from '../../assets/mytrips/ic-addguest.svg';

const AddGuestIcon = styled(AddGuestSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '5.7rem'};
  height: ${props => props.height || '5.1rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default AddGuestIcon;
